import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, GUEST_ALL, GUEST_LIST } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const GUESTS = GLOBAL_STATE

const guestsSlice = createSlice({
  name: GUESTS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.guestList.pending, state => {
        state[GUEST_LIST].loading = true
      })
      .addCase(actionCreators.guestList.rejected, (state, action) => {
        state[GUEST_LIST].loading = false
        state[GUEST_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.guestList.fulfilled, (state, action) => {
        state[GUEST_LIST].loading = false
        state[GUEST_LIST].error = null
        state[GUEST_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.guestAll.pending, state => {
        state[GUEST_ALL].loading = true
      })
      .addCase(actionCreators.guestAll.rejected, (state, action) => {
        state[GUEST_ALL].loading = false
        state[GUEST_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.guestAll.fulfilled, (state, action) => {
        state[GUEST_ALL].loading = false
        state[GUEST_ALL].error = null
        state[GUEST_ALL].data = action.payload
      })

    builder.addCase(actionCreators.guestAllClear, state => {
      state[GUEST_ALL] = defaultState()
    })

    builder.addCase(actionCreators.guestListClear, state => {
      state[GUEST_LIST] = defaultState()
    })
  },
})

export const { reducer: guestsReducer } = guestsSlice
